/* SANIKB homepage · Canton Fair "Request a meeting" form.  [Claude 2026-09-30] Local mockup, not published.

   Boss 9/30: the button opens a window where the visitor picks the fair day(s) and a time slot (one-hour slots first;
   08:00–16:00, or a longer span, is allowed), leaves First name + Email (required), WhatsApp and a comment (optional);
   it reaches the sales inbox like any other inquiry, labelled with its source.

   - Opens only while the fair is ahead or running (the button reads "Request a meeting"; from the last day it is
     "Get a quote" and stays a plain link). Without JavaScript the button is a plain link to the contact page.
   - Days already over (during the fair, by the Guangzhou date canton-fair.js shows) cannot be picked.
   - "Any time, 08:00–16:00" excludes the single hours and vice versa.
   - Submit: the picked days / hours are written into hidden fields, plus a summary into contact[body] (the email's main
     text; also satisfies the site-wide non-empty body guard). The optional note is contact[Meeting note].
   - Review page (the section carries data-cf-preview, or the page is a local file): nothing is posted; the thank-you
     screen says so. On the live theme the form is {% form 'contact' %} with {% render 'sk-contact-botgate' %} inside
     (quality score, attribution, bot screen, like every SANIKB inquiry form) and posts natively; the section then
     reopens the dialog on the thank-you screen when form.posted_successfully? (Liquid) is true.
   Live-theme safeguards (pre-launch review, 9/30), because sk-contact-botgate screens the submit before this script:
   - the hidden fields (incl. contact[body], which the bot screen scores) are kept filled on every input, not just at
     submit; the native validity mirrors validate() (setCustomValidity), so an incomplete attempt is not counted as a
     submission (a quick corrected retry would otherwise be flagged "rapid_repeat" and lose the ad conversion);
   - the button click validates first and, within 3.6 s of opening, waits before posting (the bot screen silently drops
     submits in the first 3 s); after a valid submit the button reads "Sending…" and further clicks are ignored;
   - the thank-you screen opens after a post only when this form was the one sent (sessionStorage cfMeetingSent, 10 min):
     form.posted_successfully? is true for any contact form posted from the page.
   Every class starts with cf-. */
(function () {
  'use strict';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    // [ChatGPT 2026-10-01] Translate customer-facing messages; retain English sales payload keys/values.
    var localeStrings = {};
    try { localeStrings = JSON.parse(document.getElementById('sk-canton-i18n').textContent || '{}'); } catch (_) {}
    var textDecoder = document.createElement('textarea');
    Object.keys(localeStrings).forEach(function (key) { if (typeof localeStrings[key] === 'string' && !/_html$/.test(key)) { textDecoder.innerHTML = localeStrings[key]; localeStrings[key] = textDecoder.value; } });
    function tr(key, fallback, vars) {
      return String(localeStrings[key] || fallback).replace(/\{\{\s*(\w+)\s*\}\}|__sk_(\w+)__/g, function (match, a, b) { var name = a || b; return vars && Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match; });
    }
    var dlg = root.querySelector('.cf-dialog'), form = root.querySelector('[data-cf-meeting]') || root.querySelector('#CfMeetingForm');
    var btn = root.querySelector('.cf-go');
    if (!dlg || !form || !btn || typeof dlg.showModal !== 'function') return;   // old browsers: the link stays a link
    var done = dlg.querySelector('.cf-mt-done');
    var days = [].slice.call(form.querySelectorAll('[data-cf-mt-day]'));
    var slots = [].slice.call(form.querySelectorAll('[data-cf-mt-slot]'));
    var any = form.querySelector('[data-cf-mt-any]');
    var nameEl = form.querySelector('[name="contact[First name]"]'), emailEl = form.querySelector('[name="contact[email]"]');
    var phoneEl = form.querySelector('[name="contact[phone]"]');
    var noteEl = form.querySelector('[name="contact[Meeting note]"]'), waEl = form.querySelector('[name="contact[WhatsApp]"]');
    var out = function (k) { return form.querySelector('[data-cf-mt-out="' + k + '"]'); };
    var preview = root.hasAttribute('data-cf-preview') || location.protocol === 'file:';
    var lastFocus = null, tried = false, openedAt = 0, sending = false;
    var submitBtn = form.querySelector('.cf-mt-submit'), KEY = 'cfMeetingSent';
    var stallTimer = null;
    window.addEventListener('submit', function(e){
      if (e.target !== form) { try { sessionStorage.removeItem(KEY); } catch(_) {} }
    }, true);

    // the button opens the dialog only while it reads "Request a meeting" (states soon / eve / on)
    function meetingOpen() {
      var sp = btn.querySelector('[data-cf-show~="soon"]');
      return !!sp && !sp.hidden;
    }
    function todayIndex() {                 // during the fair: 1-5 from the status line canton-fair.js keeps current
      var on = root.querySelector('.cf-status[data-cf-show="on"]');
      if (!on || on.hidden) return 0;
      var el = root.querySelector('[data-cf-num="day"]');
      var sr = el && el.querySelector('.cf-sr');   // canton-fair.js splits the digits: read the screen-reader copy
      var n = parseInt(((sr || el) || {}).textContent, 10);
      return n > 0 ? n : 0;
    }
    function syncDays() {
      var t = todayIndex();
      days.forEach(function (d) {
        var past = t && +d.getAttribute('data-cf-mt-day') < t;
        d.disabled = !!past;
        if (past) d.checked = false;
        d.closest('.cf-mt-day').classList.toggle('cf-is-past', !!past);
      });
    }

    function open(e) {
      if (!meetingOpen()) return;          // last day / after: plain "Get a quote" link
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      syncDays();
      form.hidden = false; done.hidden = true;
      document.documentElement.classList.add('cf-dialog-open');
      dlg.showModal(); openedAt = Date.now(); constrain(); fill();
      var first = days.filter(function (d) { return !d.disabled; })[0];
      (first || nameEl).focus({preventScroll: true});
    }
    function close() {
      if (dlg.open) dlg.close();
    }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('cf-dialog-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({preventScroll: true});
    });
    btn.addEventListener('click', open);
    [].forEach.call(dlg.querySelectorAll('[data-cf-mt-close]'), function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });   // the backdrop

    // "Any time" and single hours exclude each other
    slots.forEach(function (s) {
      s.addEventListener('change', function () {
        if (!s.checked) return;
        if (s === any) slots.forEach(function (o) { if (o !== any) o.checked = false; });
        else any.checked = false;
      });
    });

    function checked(list) { return list.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); }
    function slotText(v) {                  // consecutive hours read as one span: 09:00–10:00, 10:00–11:00 -> 09:00–11:00
      if (!v.length || /Any time/.test(v[0])) return v.join(', ');
      var spans = [], a = null, b = null;
      v.forEach(function (x) {
        var p = x.split('–');
        if (b === p[0]) { b = p[1]; return; }
        if (a) spans.push(a + '–' + b);
        a = p[0]; b = p[1];
      });
      if (a) spans.push(a + '–' + b);
      return spans.join(', ');
    }

    function showErr(id, on) { var el = dlg.querySelector('#' + id); if (el) el.hidden = !on; }
    function validate(focus) {
      var d = checked(days), s = checked(slots);
      var okD = d.length > 0, okS = s.length > 0;
      var okN = nameEl.value.trim().length > 0, okE = EMAIL.test(emailEl.value.trim());
      var okP = phoneEl.value.trim().length > 0;
      showErr('cf-mt-err-day', !okD); showErr('cf-mt-err-slot', !okS);
      showErr('cf-mt-err-name', !okN); showErr('cf-mt-err-email', !okE); showErr('cf-mt-err-phone', !okP);
      nameEl.setAttribute('aria-invalid', okN ? 'false' : 'true');
      emailEl.setAttribute('aria-invalid', okE ? 'false' : 'true');
      phoneEl.setAttribute('aria-invalid', okP ? 'false' : 'true');
      form.querySelector('[data-cf-mt-group="day"]').classList.toggle('cf-is-invalid', !okD);
      form.querySelector('[data-cf-mt-group="slot"]').classList.toggle('cf-is-invalid', !okS);
      if (focus) {
        var firstBad = !okD ? days.filter(function (x) { return !x.disabled; })[0] : !okS ? slots[0] : !okN ? nameEl : !okE ? emailEl : !okP ? phoneEl : null;
        if (firstBad) firstBad.focus();
      }
      return okD && okS && okN && okE && okP;
    }
    // native validity = validate(): the site's bot screen skips a submit while form.checkValidity() is false
    function constrain() {
      var okD = checked(days).length > 0, okS = checked(slots).length > 0;
      var firstDay = days.filter(function (x) { return !x.disabled; })[0];
      days.forEach(function (x) { x.setCustomValidity(''); });
      if (firstDay) firstDay.setCustomValidity(okD ? '' : tr('day_error', "Choose at least one day."));
      slots[0].setCustomValidity(okS ? '' : tr('time_error', "Choose a time."));
      nameEl.setCustomValidity(nameEl.value.trim() ? '' : tr('name_error', "Enter your first name."));
      emailEl.setCustomValidity(EMAIL.test(emailEl.value.trim()) ? '' : tr('email_error', "Enter a valid email address."));
      phoneEl.setCustomValidity(phoneEl.value.trim() ? '' : tr('phone_error', "Please enter your phone number."));
    }
    // the hidden fields, kept current (the bot screen reads contact[body] before the submit handler below runs)
    function fill() {
      var d = checked(days), s = slotText(checked(slots));
      var name = nameEl.value.trim(), note = noteEl.value.trim(), wa = waEl.value.trim();
      var when = d.join(', ') + ' · ' + s + ' (Guangzhou time, GMT+8)';
      out('days').value = d.join(', ');
      out('slots').value = s;
      out('summary').value = 'Canton Fair meeting · ' + when;
      out('body').value = [
        'Canton Fair 2026 meeting request (140th Canton Fair, Phase 2, Hall 10.1, Booth L27)',
        'Day(s): ' + d.join(', '),
        'Time (Guangzhou, GMT+8): ' + s,
        'First name: ' + name,
        'Email: ' + emailEl.value.trim(),
        'Phone: ' + phoneEl.value.trim(),
        'WhatsApp: ' + (wa || '—'),
        'Comment: ' + (note || '—'),
        'Source: sanikb.com homepage · Canton Fair block · Request a meeting'
      ].join('\n');
      var displayDays = days.filter(function (d) { return d.checked; }).map(function (d) { return d.getAttribute('data-cf-mt-display') || d.value; }).join(', ');
      var displayTime = any.checked ? tr('any_time_summary', 'Any time 08:00–16:00') : s;
      return {name: name, when: tr('when', '{{ days }} · {{ time }} (Guangzhou time, GMT+8)', {days: displayDays, time: displayTime})};
    }
    // once a submit was tried, errors clear as soon as the visitor fixes them
    form.addEventListener('input', function () { constrain(); fill(); if (tried) validate(false); });
    form.addEventListener('change', function () { constrain(); fill(); if (tried) validate(false); });

    // the click comes before the submit event (Enter in a field also clicks the default button)
    submitBtn.addEventListener('click', function (e) {
      constrain(); fill();
      if (sending) { e.preventDefault(); return; }
      tried = true;
      if (!validate(true)) { e.preventDefault(); return; }
      if (preview) return;
      var wait = openedAt + 3600 - Date.now();
      if (wait > 0) {                        // too early for the bot screen: post a moment later
        e.preventDefault(); busy();
        setTimeout(function () { sending = false; post(); }, wait);
      }
    });
    function resetSending() {
      clearTimeout(stallTimer);
      sending = false; submitBtn.textContent = tr('send_request', "Send request"); submitBtn.removeAttribute('aria-disabled');
    }
    function busy() {
      sending = true; submitBtn.textContent = tr('sending', "Sending…"); submitBtn.setAttribute('aria-disabled', 'true');
      clearTimeout(stallTimer); stallTimer = setTimeout(resetSending, 12000);
    }
    addEventListener('pagehide', function(){ clearTimeout(stallTimer); });
    function post() {
      if (form.requestSubmit) form.requestSubmit(submitBtn); else submitBtn.click();
    }

    form.addEventListener('submit', function (e) {
      tried = true; constrain();
      if (sending || !validate(true)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var f = fill();
      if (preview) {                         // review page: do not post anything
        e.preventDefault();
        thanks(f.name, f.when, true);
        return;
      }
      // live: the native POST goes ahead (sk-contact-botgate has already added score / attribution / bot screen)
      busy();
      try { sessionStorage.setItem(KEY, String(Date.now())); } catch (_) {}
    });
    constrain(); fill();
    // back/forward cache: a page restored after the post must not keep a stuck "Sending…" button
    addEventListener('pageshow', function (e) {
      if (e.persisted) resetSending();
    });

    // live theme: after the native POST the page reloads with ?contact_posted=true; the section marks the form
    // (form.posted_successfully?) and the dialog reopens on the thank-you screen
    var sentAt = 0;
    try { sentAt = +sessionStorage.getItem(KEY) || 0; sessionStorage.removeItem(KEY); } catch (_) {}
    var ownAttempt = sentAt && Date.now() - sentAt >= 0 && Date.now() - sentAt < 600000;
    if (form.querySelector('[data-cf-mt-posted]') && ownAttempt) {
      lastFocus = btn;
      dlg.querySelector('[data-cf-mt-done-name]').parentNode.textContent = tr('thanks', "Thank you.");
      dlg.querySelector('[data-cf-mt-done-when]').hidden = true;
      dlg.querySelector('[data-cf-mt-preview]').hidden = true;
      form.hidden = true; done.hidden = false;
      document.documentElement.classList.add('cf-dialog-open');
      dlg.showModal(); done.focus({preventScroll: true});
    } else if (form.querySelector('[data-cf-mt-errors]') && ownAttempt) {
      lastFocus = btn;
      form.hidden = false; done.hidden = true;
      document.documentElement.classList.add('cf-dialog-open');
      dlg.showModal(); form.querySelector('[data-cf-mt-errors]').focus({preventScroll: true});
    }

    function thanks(name, when, isPreview) {
      dlg.querySelector('[data-cf-mt-done-name]').textContent = name;
      dlg.querySelector('[data-cf-mt-done-when]').textContent = when;
      dlg.querySelector('[data-cf-mt-preview]').hidden = !isPreview;
      form.hidden = true; done.hidden = false;
      done.focus({preventScroll: true});
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('.cf'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
